module.exports = __webpack_public_path__ + "assets/lessons/hr/lesson4/pages/lesson_4_6.pdf";